import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	globalTransition: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	globalTransition: {
		id: 'issue-field-status.status-view.transition.with-label.global-transition',
		defaultMessage: 'Transition to',
		description:
			'Global transition button label. If button is clicked - status will change to the selected one',
	},
});
export default messages;
